export default __webpack_public_path__ + "static/media/download-modal-share.b51ad481.svg";